import {
  ChangeDetectionStrategy,
  Component,
  OnInit,
  input,
  output,
  signal,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
  ButtonComponent,
  IconButtonComponent,
  IconComponent,
} from '@totalenergiescode/tds-angular';
import { ViewMode } from '../../../domain/models';

/**
 * Explorer Toolbar Component
 * Provides search and action buttons for the asset explorer
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FormsModule, IconComponent, IconButtonComponent, ButtonComponent],
  selector: 'lib-explorer-toolbar',
  standalone: true,
  styleUrl: './explorer-toolbar.component.scss',
  templateUrl: './explorer-toolbar.component.html',
})
export class ExplorerToolbarComponent implements OnInit {
  // Expose ViewMode enum for template
  readonly ViewMode = ViewMode;

  // Inputs
  searchQuery = input<string>('');
  isLoading = input<boolean>(false);
  viewMode = input<ViewMode>(ViewMode.INSTANCE);

  // Outputs
  searchChange = output<string>();
  refresh = output<void>();
  expandAll = output<void>();
  collapseAll = output<void>();
  viewModeChange = output<ViewMode>();

  // Local state for search input
  searchValue = signal('');

  ngOnInit(): void {
    this.searchValue.set(this.searchQuery());
  }

  /**
   * Handle search input change
   */
  onSearchChange(value: string): void {
    this.searchValue.set(value);
    this.searchChange.emit(value);
  }

  /**
   * Handle refresh button click
   */
  onRefresh(): void {
    this.refresh.emit();
  }

  /**
   * Handle expand all button click
   */
  onExpandAll(): void {
    this.expandAll.emit();
  }

  /**
   * Handle collapse all button click
   */
  onCollapseAll(): void {
    this.collapseAll.emit();
  }

  /**
   * Handle view mode change
   */
  onViewModeChange(mode: ViewMode): void {
    this.viewModeChange.emit(mode);
  }

  /**
   * Check if a view mode is active
   */
  isViewModeActive(mode: ViewMode): boolean {
    return this.viewMode() === mode;
  }
}
